import { Directives } from "./Directives";
import { Operation } from "./OperationBase";
import {ComponentType} from "./ContentComponent";

export function CreateOperationAttr(node:HTMLElement,name:string,getVal:(args:any[])=>any,curComp:ComponentType,content:any): Operation {
  let LastVar=content;
  let DirUpdate:(v:any)=>void;

  if (name.charAt(0)==="@") {
    // event
    if(typeof content !=="function") throw new Error("Katla: '" + name + "' handler must be function");
    let parts=name.substr(1).split("|");
    node.addEventListener(parts[0], e => {
      if(parts.indexOf("self")>0 && e.target!==node) return;
      if(parts.indexOf("default")<1) e.preventDefault();
      if(parts.indexOf("stop")>0) e.stopPropagation();
      let frv=LastVar(e);
      if(!parts.includes("noredraw")) {
        if (frv instanceof Promise) {
          frv.then(() => curComp.$redraw());
        } else {
          curComp.$redraw();
        }
      }
    },
    { capture: parts.indexOf("capture")>0,
      once: parts.indexOf("once")>0,
      passive: parts.indexOf("passive")>0 });  


  } else if (name.charAt(0)===".") {
    // property
    (<any>node)[name.substr(1)]=content;

  } else if (name.charAt(0)==="#") {
    // directive
    let parts=name.substr(1).split("|");
    let hh=Directives.get(parts[0]); 
    if(hh===undefined) throw new Error("Katla: Unknown directive '#"+parts[0] + "'");
    DirUpdate=hh(node,content,parts.slice(1),()=>curComp.$redraw());

  } else {
    // plain old attribute
    if(content===false || content===null || content===undefined) {
      // Do nothing - on creation there is no need to remove attribute if null (won't be there)
    } else if(content===true) {
      node.setAttribute(name,"");
    } else {
      node.setAttribute(name,content.toString());
    }
  }

  return {
    GetData:getVal,
    Update: (v:any)=> {
      if(v===LastVar && typeof v !=="object") return;
      LastVar=v;
      if (name.charAt(0)==="@") {
        // event
        if(typeof v !=="function") throw new Error("Katla: " + name + " handler must be function");
        // do nothing - LastVar already set to new function reference
      } else if(name.charAt(0)===".") {
        // property
        (<any>node)[name.substr(1)]=v;
      } else if(name.charAt(0)==="#") {
        // directive
        DirUpdate(v);
      } else {
        if(v===false || v===null || v===undefined) {
          node.removeAttribute(name);
        } else if(v===true) {
          node.setAttribute(name,"");
        } else {
          node.setAttribute(name,v.toString());      
        }
      }
    },
    
    Unload:()=>{}
  }
}
